module.exports = __webpack_public_path__ + "media/categories/1079-b74e9da4.svg";